import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class CheckOpenHoursCustomerCareService extends Service {
  constructor({config}) {
    super()
    this._config = config
    this._easter = new Date()
  }

  isWeekend(date) {
    const day = date.getDay()
    return day === 0 || day === 6
  }

  isHolidays(date) {
    return (date.getMonth() === 6 && date.getDate() > 2) || (date.getMonth() === 7 && date.getDate() < 28)
  }

  isEasterWeek(date) {
    const _isResurrectionSunday = this.isEaster(this._easter.getFullYear())
    const _isPascuaMonday = this.isEasterMonday()

    return _isPascuaMonday < date && _isResurrectionSunday > date
  }

  isEaster(year) {
    let {M, N, a, b, c, d, e, f, day, month} = 0

    if (year > 1900 && year < 2099) {
      M = 24
      N = 5
    } else if (year > 2100 && year < 2199) {
      M = 24
      N = 6
    } else if (year > 2200 && year < 2299) {
      M = 25
      N = 0
    }
    a = year % 19
    b = year % 4
    c = year % 7
    d = (19 * a + M) % 30
    e = (2 * b + 4 * c + 6 * d + N) % 7
    f = d + e
    if (f < 10) {
      day = f + 22
      month = 3
    } else {
      day = f - 9
      month = 4
    }
    if (day === 26 && month === 4) {
      day = 19
    }
    if (day === 25 && month === 4 && d === 28 && e === 6 && a > 10) {
      day = 18
    }
    month = month - 1 // To match the month since 0 is January
    this._easter = new Date(year, month, day)
    return this._easter
  }

  isEasterMonday() {
    const time = this._easter.getTime()
    const days = 6 * 24 * 60 * 60 * 1000
    const monday = time - days
    const mondayDate = new Date(monday)
    return mondayDate
  }

  isOnTime(date, start, end) {
    const hours = date.getHours()
    return hours >= start && hours < end
  }

  isCompactPeriod(date) {
    return this.isHolidays(date) || this.isEasterWeek(date)
  }

  @inlineError
  execute(date) {
    const {date: clientDate} = date.toJSON()
    const _date = new Date(clientDate)

    if (this.isWeekend(_date)) return Promise.resolve(false)

    const isCompactPeriod = this.isCompactPeriod(_date)
    if (_date.getDay() === 5) return Promise.resolve(this.isOnTime(_date, 9, isCompactPeriod ? 14 : 15))

    return Promise.resolve(this.isOnTime(_date, isCompactPeriod ? 8 : 9, isCompactPeriod ? 14 : 18))
  }
}
